import { useCallback, useState } from 'react';

import { HonorificBlockTimesList } from '../../../compositions/honorific-block-times/list/honorific-block-times-list';
import { HonorificBlockTimesModal } from '../../../compositions/honorific-block-times/modals/honorific-block-times-modal';
import { useCurrentHealthProvider } from '../../../data/data/health-providers/use-current-health-provider';
import { useHonorificBlockTimeItems } from '../../../data/data/honorific-block-times/use-honorific-block-time-items';
import { HonorificBlockTimeItemDataFragment } from '../../../data/types/api/graphql';
import { Content } from '../../../elements/content/content';

export function AdminHonorificBlockTimesPage() {
  const { healthProvider } = useCurrentHealthProvider();

  const [honorificBlockTimesModalOpen, setHonorificBlockTimesModalOpen] =
    useState<HonorificBlockTimeItemDataFragment | false>(false);

  const {
    data: honorificBlockTimeItemsData,
    loading: honorificBlockTimeItemsLoading,
  } = useHonorificBlockTimeItems({
    healthProviderId: healthProvider?.id,
  });

  const onHandleHonorificBlockTime = useCallback(
    (value: HonorificBlockTimeItemDataFragment) => {
      setHonorificBlockTimesModalOpen(value);
    },
    []
  );

  return (
    <>
      <Content>
        <HonorificBlockTimesList
          loading={honorificBlockTimeItemsLoading}
          items={honorificBlockTimeItemsData}
          onClick={onHandleHonorificBlockTime}
        />
      </Content>
      {honorificBlockTimesModalOpen && healthProvider && (
        <HonorificBlockTimesModal
          healthProvider={healthProvider}
          honorificBlockTimeItemData={honorificBlockTimesModalOpen}
          onClose={() => {
            setHonorificBlockTimesModalOpen(false);
          }}
        />
      )}
    </>
  );
}
